import { render, staticRenderFns } from "./rightClick.vue?vue&type=template&id=3186cb46&scoped=true"
import script from "./rightClick.vue?vue&type=script&lang=js"
export * from "./rightClick.vue?vue&type=script&lang=js"
import style0 from "./rightClick.vue?vue&type=style&index=0&id=3186cb46&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3186cb46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3186cb46')) {
      api.createRecord('3186cb46', component.options)
    } else {
      api.reload('3186cb46', component.options)
    }
    module.hot.accept("./rightClick.vue?vue&type=template&id=3186cb46&scoped=true", function () {
      api.rerender('3186cb46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/cloudfile/components/rightClick.vue"
export default component.exports